import * as React from "react";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { Box, Button, Grid, List, ListItem, Typography } from "@mui/material";
import PushPinIcon from "@mui/icons-material/PushPin";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import { useDispatch } from "react-redux";
import { setNoticeSummary } from "../../redux/summaryCount/summaryCountAction";
const style = {
  position: "absolute" as "absolute",
  top: "10%",
  left: "19%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: "10px 50px 0 50px ",
};

const Item = styled(Paper)(() => ({
  backgroundColor: "#fff",
  textAlign: "center",
}));
export default function ModalSummaryNotice({
  openModel,
  setOpenModal,
  detail,
  count,
}: any) {
  const [open, setOpen] = React.useState(openModel);
  const dispatch = useDispatch();
  const handleClose = () => {
    setOpen(false);
    // setOpenModal(false);
    dispatch(setNoticeSummary({ hasInstant: false, count: count }));
  };
  React.useEffect(() => {
    setOpen(openModel);
  }, [openModel]);

  return (
    <div>
      <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{
            borderRadius: "6px",
            width: "26%",
            border: "solid 1px #DAE0E4",
            outline: 0,
          }}
          className="  "
        >
          {/* <Grid xs={12} sm={12} md={12} lg={2} textAlign={'center'} >
                            {card === "" ? "" : }
                    </Grid> */}
          <Grid container spacing={2}>
            <Grid container xs={12} className="ActivePlansCardContainer">
              <Grid item xs={12} md={12}>
                <b className="colorTitle">
                  {" "}
                  اطلاعیه‌ی <span style={{ color: "#E6123D" }}>
                    "فوری"
                  </span>{" "}
                  دارید. برای بازدید کلیک کنید.
                </b>
              </Grid>
              <Grid item xs={9} md={9} style={{ textAlign: "left" }}></Grid>
              <Grid item xs={3} md={3} style={{ textAlign: "left" }}>
                <Button
                  onClick={handleClose}
                  fullWidth
                  className="btnForm  DangerDefault"
                >
                  بازدید
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
